export default "/fonts/iconfont.svg?4434225f11cb903d3a6ae0d5c18af63f";